import React, {useRef, useState} from 'react';

import {Button, Text, addGenericErrorToast} from '@albert-io/atomic';
import notifier from '@albert-io/notifier';

import {usePerformSignupStep} from '../usePerformSignupStep';
import AccountTypeSelector, {type AccountType} from '../AccountTypeSelector';

import OnboardingPageLayout from './OnboardingPageLayout';

export default function AccountTypeSelectionPrompt() {
  const [selectedType, setSelectedType] = useState<AccountType | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submittingRef = useRef(false);
  const performSignupStep = usePerformSignupStep();

  const handleContinue = async () => {
    if (!selectedType || submittingRef.current) return;
    submittingRef.current = true;
    setIsSubmitting(true);
    try {
      await performSignupStep({accountTypeSelection: {accountType: selectedType}});
    } catch (e) {
      notifier.notify(e instanceof Error ? e : new Error('Failed to set account type'), {
        tags: 'AccountTypeSelectionPrompt'
      });
      addGenericErrorToast();
    } finally {
      submittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <OnboardingPageLayout>
      <div className='flex w-full flex-col items-center justify-center gap-x5'>
        <Text className='text-xxl font-black'>Get started as a(n)...</Text>

        <AccountTypeSelector
          selectedType={selectedType}
          onSelect={setSelectedType}
          disabled={isSubmitting}
        />

        <Button
          className='w-full max-w-[432px]'
          disabled={!selectedType || isSubmitting}
          onClick={handleContinue}
          roundness='pill'
          size='l'
        >
          {isSubmitting ? 'Saving...' : 'Continue'}
        </Button>
      </div>
    </OnboardingPageLayout>
  );
}
